import Vue from 'vue'
import Router from 'vue-router'

// Auth
import LoginPage from '@pages/auth/LoginPage'
import ForgotPasswordPage from '@pages/auth/ForgotPasswordPage'
import ResetPasswordPage from '@pages/auth/ResetPasswordPage'

// Admin (Not being used)
import AdminLandingPage from '@pages/admin/AdminLandingPage'
import AdminProvidersPage from '@pages/admin/AdminProvidersPage'
import AdminUploadsPage from '@pages/admin/AdminUploadsPage'
import AdminPatientsPage from '@pages/admin/AdminPatientsPage'
import AdminFileUploadPage from '@pages/admin/AdminFileUploadPage'
// Admin Requests
import AdminRequestPage from '@pages/admin/AdminRequestsPage'
import AdminRequestDetailPage from '@pages/admin/AdminRequestDetailPage'
// Admin Documents
import AdminDocumentsPage from '@pages/admin/AdminDocumentsPage'
import AdminDocumentPage from '@pages/admin/AdminDocumentPage'
// Admin User-groups
import AdminUserGroupsPage from '@pages/admin/AdminUserGroupsPage'

// Guards
import guards from '@router/guards'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: AdminLandingPage,
      ...guards
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage,
      meta: {
        hideHeader: true,
        replaceHeader: true
      },
      beforeEnter: (to, from, next) => {
        if (from.name === 'UploadFilePage') {
          to = from
          return
        }
        next()
      }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPasswordPage',
      component: ForgotPasswordPage,
      meta: {
        hideHeader: true
      }
    },
    {
      path: '/reset-password',
      name: 'ResetPasswordPage',
      component: ResetPasswordPage,
      meta: {
        hideHeader: false
      },
      ...guards
    },
    {
      path: '/admin',
      name: 'AdminLandingPage',
      component: AdminLandingPage,
      ...guards
    },
    {
      path: '/admin/requests',
      name: 'AdminRequestsPage',
      component: AdminRequestPage,
      meta: {
        displayName: 'Pending Requests'
      },
      ...guards
    },
    {
      path: '/admin/providers',
      name: 'AdminProvidersPage',
      component: AdminProvidersPage,
      ...guards
    },
    {
      path: '/admin/patients',
      name: 'AdminPatientsPage',
      component: AdminPatientsPage,
      ...guards
    },
    {
      path: '/admin/request/:id',
      name: 'AdminRequestDetailPage',
      component: AdminRequestDetailPage,
      meta: {
        replaceHeader: true,
        sidebarContent: true
      },
      ...guards
    },
    {
      path: '/admin/uploads',
      name: 'AdminUploadsPage',
      component: AdminUploadsPage,
      ...guards
    },
    {
      path: '/admin/fileupload',
      name: 'AdminFileUploadPage',
      component: AdminFileUploadPage,
      ...guards
    },
    {
      path: '/admin/documents',
      name: 'AdminDocumentsPage',
      component: AdminDocumentsPage,
      meta: {
        displayName: 'Inbound Faxes'
      },
      ...guards
    },
    {
      path: '/admin/documents/:id',
      name: 'AdminDocumentPage',
      component: AdminDocumentPage,
      meta: {
        replaceHeader: true,
        sidebarContent: true
      },
      ...guards
    },
    {
      path: '/admin/user-groups',
      name: 'AdminUserGroupsPage',
      component: AdminUserGroupsPage,
      ...guards
    },
    {
      path: '*',
      redirect: '/',
      beforeEnter: (to, from, next) => {
        console.log('%c ERROR:', 'color:white;background:red', 'Route not found', to.name)
        next()
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/router.js